export const LOGIN = 'LOGIN';
export const LOADING = 'LOADING';
export const LOGOUT = 'LOGOUT';